// Services
import { configureReservationIdentifierSignalRQueryInvalidation } from '../../store/Reservations/ReservationIdentifiers/ReservationIdentifiers.signalr';
import { SignalRQueryEvent } from '../../models/SignalRQueryEvent';
import { configureReservationSignalRQueryInvalidation } from '../../store/Reservations/Reservations.signalr';

export const configureQueryEvents = ({ hubConnection, queryClient }: SignalRQueryEvent) => {
  configureReservationSignalRQueryInvalidation({ hubConnection, queryClient });
  configureReservationIdentifierSignalRQueryInvalidation({ hubConnection, queryClient });
};
